import CryptoJS from 'crypto-js'
import {storage} from '@/services/storage'
import {CRYPTO_KEY, PRODUCTS_KEY} from '@/stores/auth/constants/configurations'
import {ACCESS_TOKEN_KEY} from '@/constants/auth-constants'
import {ROUTES} from '@/router/routes'
import {routesPermissionMap} from '@/router/routes-permission-map'
import {getRouterStore} from '@/router/utils'
import {menu} from '@/router/menu'

export const savePermissions = (permissions: string[]) => {
    const encrypted = CryptoJS.AES.encrypt(JSON.stringify(permissions), CRYPTO_KEY).toString()
    storage.set('permissions', encrypted)
}

export const getPermissions = () => {
    const encrypted = storage.get('permissions')
    if (!encrypted) return null

    const bytes = CryptoJS.AES.decrypt(encrypted, CRYPTO_KEY)
    const decrypted = bytes.toString(CryptoJS.enc.Utf8)
    return JSON.parse(decrypted || '[]')
}

export const hasPermissions = (permissions: string[]) => {
    if (!permissions || permissions.length === 0) return true
    return permissions.some((p) => getPermissions()?.indexOf(p) >= 0)
}

export const getProducts = () => {
    const products = storage.get(PRODUCTS_KEY)
    if (!products) return null

    return JSON.parse(products || '{}')
}

export const hasProducts = (products: string[]) => {
    if (!products || products.length === 0) return true
    return products.some((p) => getProducts() && getProducts()[p])
}

export const getRouteByPermission = (permission: string) => {
    for (const key in routesPermissionMap) {
        const value = routesPermissionMap[key]

        if (typeof value === 'string' && value === permission) {
            return key
        } else if (typeof value === 'object' && permission in value) {
            return key
        } else if (typeof value === 'object') {
            for (const nestedKey in value) {
                const nestedValue = value[nestedKey]

                if (typeof nestedValue === 'string' && nestedValue === permission) {
                    return key
                }
            }
        }
    }

    return null
}

/**
 * Returns the first accessible route for the user based on the menu structure.
 * Uses the same menu as the sidebar so the redirect always matches what the user can see.
 */
export const getHomeUrl = (permissions: string[]): string => {
    const userPermissions = permissions ?? []

    console.log('menu', menu())
    console.log('routes', routesPermissionMap)

    const findFirstLeafRoute = (items: ReturnType<typeof menu>): string | null => {
        for (const item of items) {
            // Skip external URLs (absolute URLs like FAQ)
            if (item.path && item.path.startsWith('http')) continue

            if (item.children?.length) {
                const childRoute = findFirstLeafRoute(item.children)
                if (childRoute) return childRoute
            } else if (item.path) {
                const requiredPermissions: string[] = routesPermissionMap[item.path] ?? []
                // No permissions required → accessible
                if (requiredPermissions.length === 0) return item.path
                // Check if user has at least one required permission
                if (requiredPermissions.some((p) => userPermissions.includes(p))) {
                    return item.path
                }
            }
        }
        return null
    }

    const firstRoute = findFirstLeafRoute(menu())
    return firstRoute ?? ROUTES.noPermissions
}

export const navigateUserAfterLogin = (permissions: string[]) => {
    getRouterStore().push(getHomeUrl(permissions))
}

export const isAuthenticated = () => Boolean(storage.get('email') && storage.get(ACCESS_TOKEN_KEY))

export const isActivated = () => {
    const activated = storage.get('activated')
    return activated === 'true' ? true : activated === 'false' ? false : null
}

export const isAuthenticatedAndActivated = () => isAuthenticated() && isActivated() === true

export const isLoginPage = () => window.location.pathname === ROUTES.login
